import axios from "axios";

export const getSeries = (token, seriesID) => {
  return axios
    .get(process.env.VUE_APP_API_URL + seriesID, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        authorization: token,
      },
    })
    .then(function(response) {
      return { onError: false, response };
    })
    .catch(function(error) {
      return { onError: true, error };
    });
};

export const insertSeries = (token, seriesID, body) => {
  return axios
    .post(process.env.VUE_APP_API_URL + seriesID, body, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        authorization: token,
      },
    })
    .then(function(response) {
      return { onError: false, response };
    })
    .catch(function(response) {
      return { onError: true, response };
    });
};

export const updateSeries = (token, seriesID, body) => {
  return axios
    .put(process.env.VUE_APP_API_URL + seriesID, body, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        authorization: token,
      },
    })
    .then(function(response) {
      return { onError: false, response };
    })
    .catch(function(response) {
      return { onError: true, response };
    });
};
export const getMtmImageLibrary = (
  token,
  organizationId,
  pageNumber,
  imageType
) => {
  return axios
    .get(
      process.env.VUE_APP_MTM_IMAGE_LIBRARY_URL +
        "OrganizationID=" +
        organizationId +
        "&pageNumber=" +
        pageNumber +
        "&pageSize=" +
        10 +
        "&imagetype=" +
        imageType,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          authorization: token,
        },
      }
    )
    .then(function(response) {
      return { onError: false, response };
    })
    .catch(function(error) {
      return { onError: true, error };
    });
};
